import { render, staticRenderFns } from "./roomBetSlip2.vue?vue&type=template&id=55b9d2c0&lang=pug&"
import script from "./roomBetSlip2.vue?vue&type=script&lang=js&"
export * from "./roomBetSlip2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports